import React from "react"
import { UsersBoundary } from "./boundary"
import { AllUsers, IAllUsers } from "./views/AllUsers"

export const VAllUsers = (props: IAllUsers): JSX.Element => (
  <UsersBoundary>
    <AllUsers {...props} />
  </UsersBoundary>
)
